import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >
<path d="M3067 10337 c-123 -48 -209 -140 -247 -266 -18 -58 -20 -94 -20 -433
l0 -370 -27 -22 c-16 -11 -64 -52 -108 -90 -660 -565 -1123 -1320 -1333 -2176
-148 -602 -147 -1320 4 -1940 155 -636 476 -1252 914 -1750 139 -159 393 -399
545 -516 142 -108 179 -135 255 -186 301 -198 578 -338 907 -457 472 -171 980
-252 1493 -238 276 8 461 27 685 72 1091 215 2029 838 2643 1755 297 443 494
904 605 1415 64 295 86 480 94 800 21 862 -235 1717 -730 2430 -509 732 -1217
1270 -2062 1563 -502 174 -1091 251 -1620 212 -268 -20 -498 -59 -775 -130
-169 -44 -440 -135 -535 -180 -49 -23 -138 -60 -145 -60 -5 0 -10 66 -12 148
-3 143 -4 150 -35 213 -41 83 -110 151 -193 191 -55 27 -78 32 -155 35 -75 3
-100 -1 -148 -20z m2534 -1067 c672 -49 1349 -330 1869 -775 19 -16 91 -84
159 -150 755 -734 1105 -1789 941 -2835 -80 -506 -279 -986 -584 -1409 -66
-92 -76 -104 -178 -222 -517 -594 -1231 -981 -2013 -1090 -210 -29 -548 -36
-755 -15 -312 32 -647 110 -855 200 -16 7 -46 19 -65 26 -149 56 -414 195
-575 303 -58 39 -255 185 -265 196 -3 3 -39 35 -80 70 -114 97 -277 267 -399
416 -187 229 -394 595 -505 892 -59 161 -134 435 -161 593 -9 52 -23 165 -31
250 -61 685 90 1368 431 1945 49 82 155 246 165 255 3 3 17 21 30 40 14 19 35
46 47 60 l23 25 0 -1115 c0 -1170 1 -1192 46 -1415 71 -357 229 -715 443
-1005 31 -41 60 -80 66 -86 5 -7 26 -31 45 -55 75 -95 280 -290 402 -383 49
-37 208 -146 214 -146 2 0 32 -17 66 -38 471 -287 1148 -403 1721 -297 332 62
624 176 902 350 394 247 705 587 915 1000 105 207 152 329 204 530 96 377 102
831 16 1200 -155 658 -529 1196 -1093 1572 -130 86 -368 206 -512 258 -161 58
-372 112 -535 135 -125 18 -454 24 -596 11 -364 -34 -745 -157 -1043 -338 -57
-35 -105 -63 -107 -63 -8 0 -230 -170 -274 -210 -82 -74 -75 -109 -73 363 2
232 3 432 3 443 0 21 39 49 170 121 170 95 412 198 565 244 33 9 107 31 165
48 141 42 415 87 625 104 89 8 348 6 466 -3z m34 -1595 c343 -60 651 -219 896
-464 239 -238 408 -549 468 -861 36 -191 39 -422 7 -615 -99 -586 -516 -1087
-1080 -1297 -359 -133 -817 -129 -1171 9 -126 50 -329 154 -355 183 -3 3 -21
17 -40 30 -19 13 -66 51 -105 84 -364 317 -565 736 -582 1212 -10 289 37 526
156 777 249 529 758 893 1336 957 111 12 362 4 470 -15z"/>
<path d="M4577 7076 c-59 -16 -108 -61 -139 -130 l-23 -51 0 -860 c0 -818 1
-863 19 -914 61 -176 283 -230 415 -102 85 83 83 68 91 696 6 467 10 559 24
609 65 231 261 373 487 352 119 -11 189 -53 236 -144 17 -31 35 -77 41 -102 6
-25 14 -56 18 -70 4 -14 10 -288 14 -610 7 -666 4 -642 90 -730 56 -57 106
-75 195 -67 110 8 190 71 220 171 21 71 22 1337 1 1436 -64 299 -272 484 -589
522 -165 20 -393 -23 -497 -92 -14 -9 -44 -29 -67 -45 -24 -15 -78 -64 -122
-110 l-79 -82 -6 58 c-11 94 -33 153 -76 202 -63 71 -146 92 -253 63z"/>
<path d="M5642 1673 c-7 -3 -19 -18 -27 -33 -13 -24 -15 -101 -15 -473 0 -434
0 -445 21 -471 43 -55 130 -24 145 53 l7 32 36 -34 c59 -57 110 -77 193 -77
50 0 86 6 114 19 128 58 203 207 191 379 -6 98 -29 170 -70 224 -60 79 -132
111 -243 110 -71 -1 -111 -15 -176 -65 l-46 -36 -4 166 -3 165 -28 24 c-26 22
-65 29 -95 17z m398 -425 c19 -13 45 -45 59 -73 22 -42 26 -62 26 -141 0 -83
-2 -94 -30 -139 -39 -63 -82 -89 -147 -87 -64 1 -102 24 -143 87 -28 44 -34
189 -10 253 21 55 38 78 80 103 43 27 123 25 165 -3z"/>
<path d="M3902 1654 c-33 -23 -45 -60 -32 -99 12 -36 44 -55 95 -55 42 0 75
38 75 87 0 67 -82 107 -138 67z"/>
<path d="M2244 1387 l-29 -25 -3 -306 c-2 -270 -1 -309 14 -338 21 -42 31 -48
75 -48 26 0 42 7 62 28 l27 28 0 190 c0 107 5 206 11 229 15 53 74 111 123
120 56 11 107 -8 131 -47 18 -30 20 -57 25 -265 5 -228 5 -232 29 -257 27 -29
83 -35 113 -12 33 24 38 65 38 290 0 242 -7 289 -54 350 -76 100 -264 108
-370 15 -24 -22 -46 -39 -49 -39 -2 0 -7 13 -10 28 -14 71 -83 102 -133 59z"/>
<path d="M3232 1394 c-71 -19 -107 -38 -147 -82 -55 -57 -59 -126 -10 -158 33
-21 77 -10 97 24 9 15 33 43 53 62 34 33 40 35 116 39 109 4 133 -12 153 -106
7 -30 5 -32 -31 -42 -21 -6 -94 -23 -163 -37 -217 -46 -281 -91 -288 -209 -9
-141 89 -223 255 -213 77 4 112 17 210 74 l33 19 17 -25 c33 -47 65 -70 97
-70 34 0 42 5 69 36 17 21 17 25 -2 107 -17 67 -21 118 -21 239 0 168 -12 233
-53 278 -61 69 -251 101 -385 64z m264 -426 c-10 -85 -30 -124 -80 -152 -106
-61 -226 -26 -226 66 0 65 21 80 170 118 153 39 144 42 136 -32z"/>
<path d="M3908 1395 c-44 -25 -49 -67 -46 -380 3 -270 4 -285 24 -312 30 -41
90 -44 127 -7 l27 27 0 317 0 317 -23 21 c-31 29 -75 36 -109 17z"/>
<path d="M4285 1399 c-48 -24 -50 -37 -53 -334 -2 -153 -1 -294 3 -313 14 -76
99 -109 149 -59 22 23 24 31 28 218 5 169 8 202 27 251 12 32 32 65 44 73 26
18 81 19 143 4 75 -19 113 14 100 85 -5 27 -14 36 -54 54 -66 30 -106 35 -149
21 -35 -11 -93 -62 -93 -81 0 -4 -7 -8 -15 -8 -9 0 -15 9 -15 24 0 52 -67 89
-115 65z"/>
<path d="M4995 1396 c-84 -24 -121 -44 -153 -81 -52 -58 -56 -124 -11 -157 38
-28 72 -15 114 44 43 59 83 78 164 78 80 0 109 -13 126 -55 16 -37 20 -81 8
-88 -5 -3 -64 -17 -133 -31 -248 -52 -301 -80 -335 -176 -34 -97 16 -202 117
-244 42 -18 154 -21 208 -6 20 5 62 26 94 45 67 40 82 43 91 15 10 -31 63 -70
96 -70 34 0 79 39 79 67 0 10 -5 36 -11 58 -6 22 -14 130 -18 240 -6 186 -8
204 -31 250 -26 53 -69 88 -129 106 -60 18 -220 21 -276 5z m257 -421 c-6
-109 -49 -164 -144 -185 -74 -16 -126 1 -153 52 -23 44 -15 80 27 111 26 20
228 77 258 74 11 -2 14 -14 12 -52z"/>
<path d="M6670 1400 c-108 -20 -188 -80 -209 -156 -13 -49 7 -90 48 -99 39 -8
50 -1 101 63 22 29 52 57 66 62 35 14 148 12 178 -1 25 -12 56 -72 56 -108 0
-20 -68 -42 -230 -75 -111 -23 -166 -44 -199 -78 -62 -63 -77 -138 -42 -213
42 -92 115 -129 238 -123 77 3 131 23 216 76 l27 17 41 -47 c34 -40 46 -48 75
-48 24 0 43 8 59 25 29 28 30 42 9 110 -10 35 -15 89 -15 175 2 278 -24 355
-132 398 -64 25 -211 37 -287 22z m240 -407 c0 -79 -12 -115 -51 -154 -91 -91
-259 -64 -259 43 0 66 21 81 175 119 143 35 135 36 135 -8z"/>
<path d="M8190 1397 c-118 -28 -192 -89 -201 -167 -4 -40 9 -67 41 -80 40 -17
65 -5 101 46 45 65 80 84 161 84 37 0 78 -4 93 -10 30 -11 58 -68 53 -108 -3
-30 1 -28 -208 -73 -163 -35 -184 -44 -228 -93 -70 -80 -63 -194 15 -268 87
-83 258 -78 392 11 l44 29 31 -41 c50 -66 117 -75 152 -21 16 23 16 30 1 102
-11 51 -18 137 -20 253 -2 165 -4 178 -28 225 -27 53 -70 87 -128 104 -58 17
-210 21 -271 7z m250 -414 c0 -75 -17 -119 -57 -152 -41 -33 -126 -58 -166
-47 -42 10 -77 48 -83 87 -5 30 -1 41 22 68 25 27 46 36 139 60 153 39 145 40
145 -16z"/>
<path d="M8864 1400 c-53 -21 -54 -30 -54 -368 l0 -313 25 -24 c39 -40 110
-31 137 18 7 14 14 96 18 222 7 212 15 251 61 294 26 24 75 27 144 9 39 -10
50 -10 73 2 31 18 42 54 29 92 -18 56 -150 91 -222 60 -16 -7 -43 -31 -59 -53
l-29 -41 -13 37 c-7 21 -19 44 -26 51 -18 18 -59 25 -84 14z"/>
<path d="M7252 1378 c-27 -14 -38 -51 -24 -82 14 -31 45 -36 223 -36 82 0 149
-3 149 -6 0 -4 -26 -36 -57 -73 -53 -60 -87 -98 -217 -241 -110 -121 -126
-143 -126 -175 0 -43 30 -72 82 -80 24 -4 158 -5 299 -3 236 3 259 5 278 22
27 24 27 70 1 96 -19 19 -33 20 -213 20 -107 0 -196 3 -200 6 -3 3 67 87 156
186 232 259 237 265 237 303 0 20 -8 39 -21 51 -19 18 -41 19 -283 21 -176 1
-268 -1 -284 -9z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
